export class ContributingUserModel {
    username;
    fullName;
    isToken;
    token;
}
//# sourceMappingURL=contributing-user.js.map